export default "__VITE_ASSET__Beu_7bR___"